import React, { useState } from "react";
import { apiDelete, apiPost } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";

function ContractorDeleteBidModel({
    SelectedBid,
    isOpen,
    onClose,
    GetAllAssignRequirement,
    setExpandedJob
}) {
    const [IsLoading, setIsLoading] = useState(false);

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            const response = await apiDelete(`api/contractor/DeleteRequirementBid/${SelectedBid?._id}`);

            if (response?.data) {
                toast.success(response?.message || "Bid deleted successfully!");
                onClose();
                setExpandedJob(null);
                GetAllAssignRequirement();
            } else {
                toast.error(response?.message || "Failed to delete bid");
            }
        } catch (error) {
            console.error("Error deleting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md w-full">
                <div className="flex items-center mb-6 border-b pb-3">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-bold text-gray-800">
                        Delete Bid
                    </h2>
                </div>
                <p className="text-gray-700 mb-6">
                    Are you sure you want to delete this bid? This action cannot be undone.
                </p>
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 border rounded-lg hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={IsLoading}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50"
                    >
                        {IsLoading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ContractorDeleteBidModel;
